<template>
	<div class="app-container">
		<editor v-if="!isPreview" v-model="content" :id="id" :init="editorOption"></editor>
		<!-- 富文本预览 -->
		<div class="preview" v-show="isPreview">
			<!-- 编辑状态的预览才显示关闭预览 -->
			<i v-if="readonly === false" class="el-icon-close" @click="close"></i>
			<div class="ql-container ql-snow preview">
				<div class="ql-editor">
					<div v-html="content"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import tinymce from 'tinymce/tinymce';
import Editor from '@tinymce/tinymce-vue';
import 'tinymce/themes/silver/theme';
import 'tinymce/skins/ui/oxide/skin.css';
import 'tinymce/skins/ui/oxide/content.css';
import 'tinymce/icons/default/icons.min.js';
import '@/assets/zh_CN.js'

// 列表插件
import 'tinymce/plugins/lists';
import 'tinymce/plugins/advlist';
// 上传图片插件
import 'tinymce/plugins/image';
import 'tinymce/plugins/imagetools';
// 表格插件
import 'tinymce/plugins/table';
// 自动识别链接插件
import 'tinymce/plugins/autolink';
// 预览插件
import 'tinymce/plugins/preview';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/visualchars';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/tabfocus';
// 关闭 Quickbars 插件
// import 'tinymce/plugins/quickbars'
import 'tinymce/plugins/link';
import 'tinymce/plugins/media';
import 'tinymce/plugins/print';

// 编辑器插件plugins

import 'tinymce/plugins/code';
import 'tinymce/plugins/codesample';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/pagebreak';
import 'tinymce/plugins/help';
import 'tinymce/plugins/hr';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis.js';

import { getAction, xhrRequest, normalizeUrlSlashes } from '@/utils'

let num = 1;
export default {
	name: 'tinymce',
	components: {
		Editor,
	},
	props: {
		id: {
			type: String,
			default: () => {
				num === 10000 && (num = 1);
				return `tinymce${+new Date()}${num++}`;
			},
		},
		value: {
			type: String,
			default: '',
		},
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false
        }
	},
	data() {
        const { option: { api } } = this.$attrs
        const [ action, params, headers ] = getAction(api.uploadFileUrl)
		return {
			editor: null,
			isResize: true,
			uploadFileUrl: api.uploadFileUrl, // 上传地址
			uploadType: '', // 上传文件类型
			accept: '.jpg, .jpeg, .png, .gif, .svg, .xlsx, .docx, .pdf, .mp4', // 接受文件类型
			content: '', // 传入富文本字符串
			isPreview: this.readonly, // 是否富文本预览
			isShowFilePreview: false, // 是否显示文件预览
			previewFile: {}, // 当前预览文件
			fileClickFuncList: [], // 文件点击事件监听方法，用于去除监听
			editorOption: {
				// language_url: '/tinymce/langs/zh_CN.js',
				language: 'zh_CN',
				skin_url: '/tinymce/skins/ui/oxide',
				// emoticons_database_url: '/tinymce/plugins/emoticons/js/emojis.js',
				height: 500,
				plugins:
					'lists advlist image imagetools table autolink preview visualblocks visualchars wordcount tabfocus link media print code codesample fullscreen charmap insertdatetime pagebreak help hr anchor emoticons',
				// menubar: 'file edit view format table insert',
				toolbar: [
					' bold italic underline strikethrough anchor | formatselect fontselect fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote subscript superscript removeformat',
					'undo redo | link unlink image media |hr pagebreak insertdatetime   | table tabledelete | tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | indent2em lineheight | code charmap emoticons preview print fullscreen',
				],
				images_upload_url: api.uploadFileUrl,
				images_upload_base_path: '/',
				convert_urls: false,
				images_upload_handler: (blobInfo, success, failure, process) => {
					const formData = new FormData();
					formData.append('file', blobInfo.blob());
					xhrRequest({
						url: typeof (action) === 'function' ? action() : action,
						method: 'POST',
						data: formData,
						headers
					}).then(res => {
						success(res.data.downloadUrl)
					}).catch(error => {
						failure('图片上传失败' + error.message)
					})
					// action(formData).then((res) => {
					// 	if (res.code === 200) {
					// 		success(res.data.downloadUrl);
					// 	} else {
					// 		failure('图片上传失败');
					// 	}
					// });
				},
				file_picker_callback: (callback, value, meta) => {
					console.log("file_picker_callback")
					//文件分类
					var filetype = '.pdf, .txt, .zip, .rar, .7z, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .mp3, .mp4';
					switch (meta.filetype) {
						case 'image':
							filetype = '.jpg,.jpeg,.png,.gif';
							break;
						case 'media':
							filetype = '.mp4,.mp3';
							break;
					}
					var input = document.createElement('input');
					input.setAttribute('type', 'file');
					input.setAttribute('accept', filetype);
					input.click();
					input.onchange = function () {
						var file = this.files[0];
						const formData = new FormData();
						formData.append('file', file, file.name);
						xhrRequest({
							url: typeof (action) === 'function' ? action() : action,
							method: 'POST',
							data: formData,
							headers
						}).then(res => {
							let url
							// 有centerId使用绝对路径
							if (window.$centerConfig) {
								url = normalizeUrlSlashes(window.$centerConfig.api + res.data.downloadUrl)
							} else {
								url = res.data.downloadUrl
							}
							callback(url, { title: file.name });
						})
						// var xhr
						// xhr = new XMLHttpRequest()
						// xhr.open("POST", typeof (action) === 'function' ? action() : action)
						// Object.keys(headers).map(key => {
						// 	xhr.setRequestHeader(key, headers[key])
						// })
						// xhr.onload = function () {
						// 	let json
						// 	console.log(xhr)
						// 	if(xhr.status == 200) {
						// 		json = JSON.parse(xhr.responseText)
						// 		callback(json.data.downloadUrl, { title: file.name });
						// 	} else {
						// 		throw('HTTP Error:' + xhr.status)
						// 	}
						// }
						// xhr.send(formData)

						// action(formData).then((res) => {
						// 	if (res.code === 200) {
						// 		callback(res.data.downloadUrl, { title: file.name });
						// 	}
						// });
					};
				},
				branding: false,
			},
		};
	},
	watch: {
		value: {
			handler: {
				handler(v) {
					this.content = v;
				},
				immediate: true,
			},
		},
		content: {
			handler(v) {
				this.$emit('input', v);
			},
		},
		isPreview: {
			handler(v) {
				if (v) {
					// 增加附件点击事件监听，和编辑器内不是一个dom
					this.$nextTick(() => {
						const doms = document.querySelectorAll('.preview .file-click');
						this.fileClickFuncList = [];
						if (doms?.length) {
							for (let i = 0; i < doms.length; i++) {
								const fileUrl = doms[i].getAttribute('fileUrl');
								const fileName = doms[i].getAttribute('fileName');
								const func = doms[i].getAttribute('func');
								let f = () => {
									this[func](fileUrl, fileName);
								};
								this.fileClickFuncList.push(f);
								doms[i].addEventListener('click', f);
							}
						}
					});
				} else {
					// 移除文件点击事件，否则会不断增加监听事件
					const doms = document.querySelectorAll('.preview .file-click');
					if (doms?.length) {
						for (let i = 0; i < doms.length; i++) {
							doms[i].removeEventListener('click', this.fileClickFuncList[i]);
						}
					}
				}
			},
			immediate: true,
		},
	},
	beforeDestroy() {
		if (this.editor) {
			tinymce.get(this.id).destroy();
		}
	},
	mounted() {
		tinymce
			.init({
				selector: '#' + this.id,
			})
			.then((editors) => {
				this.editor = editors[0];
			});
	},
	methods: {
		// 关闭预览
		close() {
			this.isPreview = false;
		},
	},
};
</script>

<style lang="less" scoped>
.app-container {
	width: 100%;
	height: 450px;
	::v-deep .tox-tinymce {
		height: 100% !important;
	}
	.preview {
		height: 100% !important;
		overflow-y: auto;
	}
}
</style>
<style lang="less">
.tox-tinymce-aux {
	z-index: 3000 !important;
}
</style>
